@import "config";

.menuItem {
	position: relative;

	color: $color-light-l5;
	&,
	.menuItemContent {
		transition: background 300ms ease-out;
	}
	& + .menuItem {
		margin-top: $spacing-stack-quarck;
	}

	.menuItemContent > [class~="menu-icon"] {
		pointer-events: none;
	}

	a > label,
	.menuItemContent > label {
		cursor: pointer;
	}

	.collapseIcon {
		// Apenas `transform` muda aqui (rotate 0/180). Com `all`, qualquer mudanca de
		// geometria era animada por 300ms -- inclusive a chegada do svg carregado de
		// forma assincrona -- gerando uma rajada de layout-shift a cada quadro.
		transition: transform 300ms ease-out;
		color: $color-light-l5;
		pointer-events: none;
	}

	&:not(.isItemExpanded) {
		.collapseIcon {
			transform: rotate(0deg);
		}
	}

	&:hover {
		.menuItemContent {
			background-color: var(--color-primary-dark);
		}
	}

	&:focus-within {
		.menuItemContent {
			background-color: var(--color-primary-dark);
			outline: 1px solid var(--color-primary-lightest);
			outline-offset: -1px;
		}
	}

	&:disabled {
		.menuItemContent {
			color: var(--color-dark-d5);
		}
	}

	&.isItemExpanded {
		.menuItemContent {
			background-color: var(--color-primary-darkest);
		}
		.collapseIcon {
			transform: rotate(180deg);
		}
	}

	&.active {
		.menuItemContent {
			background-color: var(--color-primary-darkest);
		}
	}

	&.menuIsExpanded {
		.runningEventsBadge {
			margin-left: auto;
		}
		.menuItemContent {
			& > label {
				display: flex;
				align-items: center;
				gap: $spacing-inline-nano;
			}
		}
	}

	&:not(.menuIsExpanded) {
		.runningEventsBadge {
			position: absolute;
			top: -4px;
			right: -6px;
		}

		.menuItemContent {
			justify-content: center;
			padding-left: $spacing-inline-quarck;

			& > label,
			.collapseIcon {
				display: none;
			}
		}
	}

	.menuItemContent {
		@include flex(row, unset, center);
		gap: $spacing-inline-nano;
		cursor: pointer;
		border-radius: $border-radius-md;
		padding-block: $spacing-stack-quarck;
		padding-right: $spacing-stack-quarck;
		padding-left: $spacing-inset-nano;
		color: currentColor;

		label {
			font-weight: $font-weight-bold;
		}

		li:focus-within {
			outline: 1.5px solid var(--color-primary-light);
			outline-offset: -1.5px;
		}

		.collapseIcon {
			margin-left: auto;
		}
	}
}

.submenuItemsContainer {
	list-style: disc;
	list-style-position: inside;
	padding-left: 0;

	li {
		position: relative;
		// Apenas `background-color` muda (hover/submenuActive); `all` animava tambem
		// padding e min-height declarados abaixo.
		transition: background-color 200ms ease-in-out;
		font-size: $font-size-xxs;
		line-height: $font-line-heights-far;
		border-radius: $border-radius-md;
		padding-block: $spacing-inline-quarck;
		padding-right: $spacing-inline-quarck;
		padding-left: $spacing-inline-xxs;
		min-height: 30px;
	}

	a {
		@include flex(row, unset, center);
		color: currentColor;

		// Solution to fill out completely the li item
		position: absolute;
		left: 0;
		top: 0;
		padding-left: $spacing-inline-sm;
		width: 100%;
		height: 100%;
		align-self: center;
	}

	li,
	li > a > label {
		cursor: pointer;
		white-space: nowrap;
		font-weight: $font-weight-bold;
		@include flex(row, normal, center);
		gap: $spacing-inline-nano;

		& > div {
			margin-block: 0;
		}
	}

	li::marker {
		margin-right: $spacing-inline-xxxs;
	}

	li:hover {
		background-color: var(--color-primary-light);
	}
	li.submenuActive {
		background-color: var(--color-primary-dark);
	}

	li + li {
		margin-top: $spacing-stack-quarck;
	}
}

.tooltipContainer {
	@include flex(column, unset, start);
	gap: $spacing-stack-quarck;

	& > header {
		@include flex(row, space-between, center);
		gap: $spacing-inline-nano;
		width: 100%;
	}

	hr {
		width: 100%;
		margin-block: $spacing-stack-quarck;
		border: 1px solid var(--color-dark-d5);
	}

	header > label,
	.submenuItemsContainer > li > a > label {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.submenuItemsContainer {
		list-style: none;
		width: 100%;
		margin-bottom: 0;

		li {
			width: 100%;
			padding-left: $spacing-inline-quarck;
			transition: background-color 0.2 ease-in;
			& > * {
				color: var(--color-light-l3);
			}

			a {
				@include flex(row, space-between, center);
				color: currentColor;
				padding-left: $spacing-inline-nano;
				gap: $spacing-inline-nano;
			}

			&.submenuActive {
				background-color: transparent;
			}

			&:hover {
				background-color: var(--color-dark-d4);
			}
		}
	}
}
